import React, { useEffect, useRef, useState } from 'react';
import Link from 'next/link'
import { NAME_PROJECT } from "../../../../settings/global";
import { getPlanByRequirements } from "../../../../helpers/data/_handlers/plans";
import styles from './StackListItem.module.scss'
import ImgCDN from "../../../../components/ImgCDN";
import { generateSlug } from "../../../../helpers/common";
import Icon from "../../../../components/Icon";
import { NAV_CUSTOM_STACK } from "../../../../settings/content/deploymentStacker";
import DraftHTML from "../../../../components/draftEditor/export/DraftHTML";
import { UI_GEOMETRY } from "../../../../helpers/ui/ui";
import { NAV_STACK_LIST } from "../../../../settings/navigation";

export default function StackListItem({
                                          app, plans, custom, apps,
                                          // redux
                                          height, width,
                                          // context
                                          scrollY
                                      }) {

    let appRef = useRef();
    let detailsRef = useRef();

    const {comingSoon, hidden} = app?.accessibility || {};
    const link = `${NAV_STACK_LIST}/${generateSlug(app.name)}`;
    const plan = getPlanByRequirements(app.requiredPlan, plans);

    const [hydrated, setHydrated] = useState(false);

    useEffect(() => setHydrated(true), []);

    const showDetailsGroup = content => {
        if (!!content?.data?.length) {
            return (
                <ul className={styles.details__group}>
                    <h4 className={styles.details__group__title}>
                        {content.title ? content.title : ''}
                    </h4>
                    {content.data.map((item, index) => {
                        const isPackage = content.type === 'apps' ? ` ${styles['details__group__content__item--package']}` : '';
                        return (
                            <div className={styles.details__group__content} key={index}>
                                <p className={`${styles.details__group__content__item}${isPackage}`}>{item.name}</p>
                            </div>
                        )
                    })}
                </ul>
            )
        } else { return null }
    };

    const showExplains = () => {

        if ((!plan?.name || !!plan.isFree) && !app.code.includes('-dev') && !app.code.includes('-formula')) return null;

        return (
            <div className={styles.details__explains}>
                {
                    plan?.name && !plan.isFree &&
                    <div className={styles.details__explains__plan}>
                        <i className={`fas fa-shopping-cart ${styles.details__explains__plan__icon}`}/>
                        <p className={styles.details__explains__plan__name}>{plan.name} plan</p>
                    </div>
                }
                {
                    app.code.includes('-dev') &&
                    <div className={styles.details__explains__type}>
                        <i className={`fas fa-cubes ${styles.details__explains__type__icon}`}/>
                        <p className={styles.details__explains__type__name}>Configurable</p>
                    </div>
                }
                {
                    app.code.includes('-formula') &&
                    <div className={styles.details__explains__origin}>
                        <ImgCDN
                            className={styles.details__explains__origin__icon}
                            src='/img/logo.svg'
                            aria-hidden="true"
                        />
                        <p className={styles.details__explains__origin__name}>{NAME_PROJECT} exclusive</p>
                    </div>
                }
                {
                    comingSoon && !hidden &&
                    <div className={styles.details__explains__soon}>
                        <i className={`fas fa-angle-double-up ${styles.details__explains__soon__icon}`}/>
                        <p className={styles.details__explains__soon__name}>Coming soon</p>
                    </div>
                }
            </div>
        )
    }

    const showAdditionalIcons = () => {

        const isDev = app.code.includes('-dev');
        const isExclusive = app.code.includes('-formula');

        if (!isDev && !isExclusive && !comingSoon && (!plan?.name || !!plan.isFree)) return null;

        return (
            <div className={styles['app__status']}>
                {
                    plan?.name && !plan.isFree &&
                    <div className={styles.app__status__plan}>
                        <i className='fas fa-shopping-cart' aria-hidden="true"/>
                    </div>
                }
                {
                    isDev &&
                    <div className={styles.app__status__dev}>
                        <i className='fas fa-cubes' aria-hidden="true"/>
                    </div>
                }
                {
                    isExclusive &&
                    <div className={styles.app__status__exclusive}>
                        <ImgCDN src='/img/logo.svg' aria-hidden="true"/>
                    </div>
                }
                {
                    comingSoon && !hidden &&
                    <div className={styles.app__status__soon}>
                        <i className='fas fa-angle-double-up' aria-hidden="true"/>
                    </div>
                }
            </div>
        )
    }

    const showDebugInfo = () => {

        if (!comingSoon && !hidden) return null;

        return (
            <div className={styles.app__icon__debug}>
                {
                    hidden &&
                    <i className={`fas fa-eye-slash ${styles.app__icon__debug__hidden}`} aria-hidden='true'/>
                }
            </div>
        )
    }

    let position = {
        top: '50%',
        right: 'auto',
        bottom: 'auto',
        left: 'var(--paddingContainerOuter)',
    }

    if (hydrated) {

        const container = document.getElementById('appList-apps-container')?.getBoundingClientRect();
        const detailsElement = detailsRef.current?.getBoundingClientRect();
        const appElement = appRef.current?.getBoundingClientRect();

        const appMiddle = appElement?.height / 2;
        const detailsPageEnd = scrollY + appElement?.top + appMiddle + detailsElement?.height;
        const detailsViewportEnd = appElement?.top + appMiddle + detailsElement?.height;
        const fitsBottom = detailsViewportEnd < container?.bottom && detailsPageEnd < scrollY + height;

        const detailsRightEnd = appElement?.left + parseFloat(UI_GEOMETRY.paddingContainerOuter) + detailsElement?.width;
        const fitsRight = detailsRightEnd < container?.right;

        position = {
            top: !fitsBottom ? 'auto' : '50%',
            right: fitsRight ? 'auto' : 'var(--paddingContainerOuter)',
            bottom: !fitsBottom ? '50%' : 'auto',
            left: fitsRight ? 'var(--paddingContainerOuter)' : 'auto',
        }
    }

    return (
        <li className={styles.layout} key={app.id}>
            <div
                className={styles.layout__container}
                style={{
                    '--details-top': position.top,
                    '--details-right': position.right,
                    '--details-bottom': position.bottom,
                    '--details-left': position.left,
                }}
                ref={appRef}
            >
                <Link
                    href={custom ? `${NAV_STACK_LIST}${NAV_CUSTOM_STACK}` : link}
                    className={styles.app}
                    tabIndex='0'
                >
                    <div className={styles.app__icon}>
                        <Icon
                            className={styles.app__icon__image}
                            icon={app.icon}
                            alt={`${app.name} logo`}
                            fallbackImages={custom ? ['/images/custom-stack.svg'] : undefined}
                            height={100}
                            width={100}
                            optimize
                        />
                        {showDebugInfo()}
                    </div>
                    <p className={styles.app__name}>{app.name}</p>
                    {showAdditionalIcons()}
                </Link>
                {
                    !custom &&
                    <div className={styles.details} ref={detailsRef}>
                        <h2 className={styles.details__name}>{app.name}</h2>
                        <div>
                            {showExplains()}
                            {
                                !!app._description &&
                                <DraftHTML
                                    className={styles.details__description}
                                    content={app._description}
                                />
                            }
                            {showDetailsGroup(app.apps)}
                            {showDetailsGroup(app.features)}
                        </div>
                    </div>
                }
            </div>
        </li>
    );
}